module.exports = __webpack_public_path__ + "static/media/businessman.b61ec96b.svg";